import { WorkspaceRole } from '../../../../../../api/workspaces/getWorkspaceMembers';
import { PermissionsByMemberType } from '../types';
import { workspaceRoleToNameMap } from '../utils/workspaceRoleToNameMap';

export function extractPermissionByMemberType({
  workspaceMemberType,
  permissionsByMemberType,
}: {
  permissionsByMemberType: PermissionsByMemberType;
  workspaceMemberType: WorkspaceRole;
}) {
  const memberTypeName = workspaceRoleToNameMap.get(workspaceMemberType);

  return permissionsByMemberType[memberTypeName] ?? false; //
}
